import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as criteria from '../criteria'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: criteria.RESOURCE.payload.dimension.partialId,
      partialId: criteria.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Actions to be taken to correct issues identified in this criteria',
    isOptional: true,
    name: 'Corrective Actions',
    partialId: PartialId.Standard.create('corrective_actions'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
